<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['产品管理', '服务商产品', title + '服务商产品']" />
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form
                ref="form"
                class="add-form"
                :rules="rules"
                :model="form"
                label-width="140px"
            >
              <el-form-item label="名称：" prop="name">
                <el-input v-model.trim="form.name" :disabled="title === '编辑'"></el-input>
              </el-form-item>
              <el-form-item label="图片：" prop="banner">
                <uploadImage @success="getPicture" :img="pictureList" :limit="20" />
              </el-form-item>
              <el-form-item label="视频：" prop="videoUrl">
                <videoUpload @success="getVideo" :list="videoList"  />
              </el-form-item>
              <el-form-item :label="isDr ? '介绍' : '产品详情：'" prop="details">
                <editor ref="editor"   @setHtml="setHtml" />
              </el-form-item>
              <el-form-item :label="isDr ? '一级类目' : '一级品类：'" prop="oneList">
                <el-checkbox-group
                  v-model="form.oneList"
                  @change="oneChange"
                  :max="3"
                >
                  <template v-for="(item, index) in selectCategoryList">
                    <el-checkbox disabled :label="item.id" :key="index">{{
                      item.name
                    }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item v-if="!isDr" label="二级品类：" prop="secondCategory">
                  <span style="margin-right: 30px" v-for="(item, index) in twoList" :key="index"><el-radio v-model="form.secondCategory" :key="inx" :label="i.id" v-for="(i, inx) in item.data">{{i.name}}</el-radio></span>
              </el-form-item>
              <el-form-item v-else label="二级类目：" prop="secondCategory">
                <el-checkbox-group v-model="testList" :max="5" @change="twoChange">
                <span style="margin-right: 30px" v-for="(item, index) in twoList" :key="index">
                  <template v-for="(i, inx) in item.data">
                    <el-checkbox :label="i.id" :key="inx">{{i.name }}
                    </el-checkbox>
                  </template>
                </span>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="寄样功能：" prop="sendSample" v-if="!isDr">
                <el-radio-group v-model="form.sendSample">
                  <el-radio :label="item.id" v-for="item in sendSamples" :key="item.id">{{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="今年新品：" prop="newProducts" v-if="!isDr">
                <el-radio-group v-model="form.newProducts">
                  <el-radio label="0">否</el-radio>
                  <el-radio label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <template v-if="isDr">
                <el-form-item label="达人类型：" prop="talentType">
                  <el-radio-group v-model="form.talentType">
                    <el-radio :label="item.id" v-for="item in talentTypeList" :key="item.id">{{item.name}}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="肖像授权证明：">
                  <div style="color: #606266">1.请按照模板格式准备证明材料，并盖章上传：</div>
                  <el-button size="small" icon="el-icon-download" type="primary" @click="downloadMb">下载模板</el-button>
                  <div style="color: #606266">2.上传盖章好的文件：</div>
                  <FileUpload @success="getUrl" :list="authCertificateList" accept="" />
                </el-form-item>
                <el-form-item label="有效期：" prop="lifespan">
                  <el-date-picker style="width: 100%" v-model="form.lifespan" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择时间">
                  </el-date-picker>
                </el-form-item>
              </template>
              <el-form-item label="排序：" prop="sort">
                <el-input-number v-model="form.sort" :min="0" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="驳回原因：" v-if="form.status === '3'">
                <p class="reject-text">{{form.reason + '，请确认修改完成后点击提交审核'}}</p>
              </el-form-item>
            </el-form>
            <div class="info-footer">
              <el-button type="primary" @click="save">提交审核</el-button>
              <el-button @click="back">取消</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import navHeader from '../../components/navHeader.vue'
import uploadImage from '../../components/xcUpload.vue'
import editor from '../../components/editor.vue'
import videoUpload from '../../components/videoUpload'
import FileUpload from '../../components/fileUpload.vue'

export default {
  data () {
    return {
      loading: true,
      id: '',
      companyId: '',
      title: '添加',
      form: {
        details: '',
        newProducts: '0',
        oneList: [],
        secondCategory: '',
        banner: '',
        sendSample: '',
        fansNum: '',
        talentType: '',
        authCertificate: '',
        lifespan: ''
      },
      pictureList: [],
      videoList: [],
      rules: {
        name: {
          required: true,
          message: '请输入中文名',
          trigger: 'blur'
        },
        banner: {
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        },
        oneList: {
          required: true,
          message: '请选择一级品类',
          trigger: 'blur'
        },
        // sendSample: {
        //   required: true,
        //   message: '请选择寄样功能',
        //   trigger: 'blur'
        // },
        secondCategory: {
          required: true,
          message: '请选择二级品类',
          trigger: 'blur'
        }
      },
      sendSamples: [
        {
          name: '可以寄样',
          id: '1'
        },
        {
          name: '可以参观/看样',
          id: '2'
        },
        {
          name: '可供产品资料',
          id: '3'
        },
        {
          name: '以上都不支持',
          id: '4'
        }
      ],
      selectCategoryList: [],
      brandCategoryList: [],
      twoList: [],
      twoData: [],
      isDr: false,
      talentTypeList: [
        {
          name: '综合',
          id: '1'
        },
        {
          name: '美妆护肤',
          id: '2'
        },
        {
          name: '种草测评',
          id: '3'
        },
        {
          name: '个护家清',
          id: '4'
        },
        {
          name: '食品饮料',
          id: '5'
        },
        {
          name: '颜值剧情',
          id: '6'
        },
        {
          name: '时尚穿搭',
          id: '7'
        },
        {
          name: '本地生活',
          id: '8'
        },
        {
          name: '影视娱乐',
          id: '9'
        },
        {
          name: '游戏',
          id: '10'
        },
        {
          name: '数码科技',
          id: '11'
        },
        {
          name: '宠物',
          id: '12'
        },
        {
          name: '母婴',
          id: '13'
        },
        {
          name: '生活vlog',
          id: '14'
        },
        {
          name: '旅行',
          id: '15'
        },
        {
          name: '动漫',
          id: '16'
        },
        {
          name: '知识分享',
          id: '17'
        },
        {
          name: '手工',
          id: '18'
        },
        {
          name: '家居',
          id: '19'
        },
        {
          name: '汽车',
          id: '20'
        }
      ],
      authCertificateList: [],
      testList: []
    }
  },
  components: {
    navHeader,
    uploadImage,
    editor,
    videoUpload,
    FileUpload
  },
  created () {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
    } else {
      this.id = ''
    }
    if (this.$route.params.type) {
      this.type = this.$route.params.type
      this.title = '编辑'
    } else {
      this.type = 'add'
      this.loading = false
      this.title = '添加'
    }
    this.getBrandCategoryList()
  },
  mounted () {
    if (this.title === '添加') {
      this.$refs.editor.initEditor()
    }
  },

  methods: {
    getDetail (id) {
      this.$http.post('/providerProduct/getById', { id }).then(res => {
        if (res.data.code === '200') {
          this.form = res.data.data
          this.$refs.editor.initEditor(this.form.details)
          this.form.newProducts = res.data.data.newProducts ? res.data.data.newProducts : '0'
          this.pictureList = this.form.banner ? this.form.banner.split(',') : []
          this.videoList = []
          let list = this.form.videoUrl ? this.form.videoUrl.split(',') : []
          list.forEach(item => {
            this.videoList.push({name: item, url: item})
          })
          this.authCertificateList = []
          let list1 = this.form.authCertificate ? this.form.authCertificate.split(',') : []
          list1.forEach(item => {
            this.authCertificateList.push({name: item, url: item})
          })
          this.testList = res.data.data.secondCategory ? res.data.data.secondCategory.split(',') : []
          this.getService()
        }
        this.loading = false
      }).catch(e => {
        console.log(e)
        this.loading = false
      })
    },
    getService () {
      this.$http.get('/company/getByProviderCompany').then(res => {
        if (res.data.code === '200') {
          this.form.oneList = res.data.data.firstCategory ? res.data.data.firstCategory.split(',') : []
          this.form.oneList.forEach((item) => parseInt(item))
          this.isDr = this.form.oneList.includes('205') || this.form.oneList.includes('206')
          this.twoList = []
          this.brandCategoryList.forEach((item) => {
            this.form.oneList.forEach((i) => {
              if (i === item.id) {
                this.selectCategoryList.push({
                  name: item.name,
                  id: item.id
                })
                this.twoList.push({
                  name: item.name,
                  id: item.id,
                  data: item.childList
                })
                console.log(this.twoList)
                let two = item.childList.map((n) => n.id)
                this.twoData.push(two.join(','))
              }
            })
          })
        }
      })
    },
    getBrandCategoryList () {
      this.$http.post('/brandCategory/getCategoryByType', { type: 4 }).then(res => {
        if (res.data.code === '200') {
          this.brandCategoryList = res.data.data
          if (this.id) {
            this.getDetail(this.id)
          } else {
            this.getService()
          }
        }
      })
    },
    oneChange () {
      this.twoList = []
      this.twoData = []
      this.brandCategoryList.forEach((item) => {
        this.form.oneList.forEach((i) => {
          if (i === item.id) {
            this.twoList.push({
              name: item.name,
              id: item.id,
              data: item.childList.map((n) => n.name)
            })
            let two = item.childList.map((n) => n.id)
            this.twoData.push(two.join(','))
          }
        })
      })
    },
    twoChange () {
      this.form.secondCategory = this.testList.join(',')
    },
    getUrl (list) {
      this.form.authCertificate = list.map(item => item.url).join(',')
    },
    getPicture (list) {
      this.form.banner = list.join(',')
    },
    getVideo (list) {
      this.form.videoUrl = list.map(item => item.url).join(',')
    },
    setHtml (html) {
      this.form.details = html
    },
    back () {
      this.$router.push('/serviceProduct')
    },
    save () {
      this.$refs.form.validate(val => {
        if (val) {
          let params = JSON.parse(JSON.stringify(this.form))
          params.firstCategory = this.form.oneList.join(',')
          delete params.oneList
          const url = this.type === 'add' ? '/providerProduct/add' : '/providerProduct/update'
          this.$http.post(url, params).then(res => {
            if (res.data.code === '200') {
              this.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定',
                showClose: false
              }).then(() => { this.$router.back() })
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(e => {
            console.log(e)
          })
        } else {
          if (!this.form.name) return this.$message.error('请输入中文名')
        }
      })
    },
    downloadMb () {
      window.location.href = 'https://oss.cbebaiwen.com/exhibitionUpload/630b04ee72b240ef94bccc7e16729e5e.docx'
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/productManagement/serviceDetail.vue